import { double_foldl } from '@vaaas/fpts/iter';
import { Vector2 } from 'three';

export function point_point_distance(a: Vector2, b: Vector2) {
    return Math.sqrt(
        (a.x - b.x)**2 + (a.y - b.y)**2
    );
}

export const copy_into = (a: Vector2) => (b: Vector2): Vector2 => {
    a.x = b.x;
    a.y = b.y;
    return a;
};

export const copy_from = (a: Vector2) => (b: Vector2): Vector2 => {
    b.x = a.x;
    b.y = a.y;
    return b;
};

export const average = (xs: Iterable<Vector2>): Vector2 => double_foldl(
    (sum: Vector2) => (x: Vector2) => {
        sum.x += x.x;
        sum.y += x.y;
        return sum;
    },
    new Vector2(0, 0),

    (len: number) => () => len + 1,
    0,

    (x: Vector2) => (n: number) => {
        x.x = x.x/n;
        x.y = x.y/n;
        return x;
    },
)(xs);

export const from_pointer = (x: PointerEvent | MouseEvent) => new Vector2(x.pageX, x.pageY);

export const is_nan = (x: Vector2) => isNaN(x.x) || isNaN(x.y);

export type Direction = 'up' | 'right' | 'under' | 'left';

export const is_opposite_direction = (a: Direction, b: Direction) => {
    switch (a) {
        case 'up':
            return b === 'under';
        case 'under':
            return b === 'up';
        case 'left':
            return b === 'right';
        case 'right':
            return b === 'left';
        default:
            return false;
    }
};

export const move_direction = (a: Vector2, b: Vector2): Direction => {
    const dx = a.x - b.x;
    const dy = a.y - b.y;
    const horizontal = Math.abs(dx) > Math.abs(dy);
    if (horizontal)
        return dx > 0 ? 'left' : 'right';
    else
        return dy > 0 ? 'up' : 'under';
};
